import { TableBuilder, TableBuilderColumn } from 'baseui/table-semantic';
import { Notification, KIND } from 'baseui/notification';
import { ParagraphSmall, LabelXSmall, HeadingXSmall } from 'baseui/typography';
import { Table } from 'baseui/table-semantic';
// api
import { useGetObjectClassByNameQuery } from '../../services/objects'
import { useGetResourceGroupByIdQuery, useGetResourceGroupSubscriptionQuery } from '../../services/resourceGroups/resourceGroupApi';
import { useGetSubscriptionByIdQuery } from '../../services/resourceGroups/subscriptionApi';
import { useStyletron } from 'baseui';
import { AccessRoles, useHasRole } from '../../hooks/useHasRole';
import { CellSelector } from './CellSelector';

export interface RowProps {
    type: string,
    name: string;
    nullable: boolean;
    value: any
}

const COLUMNS = ['Name', 'Value'];
const IGNORE_PROPS = ['id', 'schema', 'resourceGroupId', '$dtId', '$metadata'];

const ObjectPropertiesExplorer = ({ schema, livestate }: any) => {
    const hasAccessObject = useHasRole(AccessRoles.Object.Write);
    const { data, isLoading, isError, error } = useGetObjectClassByNameQuery(schema);
    const tmpdata = data ? data.properties.filter(v => !IGNORE_PROPS.includes(v.name)) : [];

    const basicinformation = [
        [
            'TwinId', livestate.id
        ],
        [
            'Name', livestate.name
        ],
        [
            'Twin Model', `${data?.namespace}.${data?.name}`
        ],
        [
            'Resource Group', livestate.id ? <ResourceGroup resourceGroupId={livestate.resourceGroupId} /> : "loading ..."
        ],
        [
            'Subscription', livestate.id ? <Subscription resourceGroupId={livestate.resourceGroupId} /> : "loading ..."
        ],
    ]

    return (
        <>
            <HeadingXSmall marginBottom={0} marginTop={'20px'}>Meta</HeadingXSmall>
            <ParagraphSmall>Basic information about this digital Twin</ParagraphSmall>
            <Table columns={COLUMNS} data={basicinformation} size='compact' />
            {isError &&
                (<Notification kind={KIND.negative} >
                    {() => JSON.stringify(error)}
                </Notification>)
            }
            <HeadingXSmall marginBottom={0} marginTop={'20px'}>Data Explorer</HeadingXSmall>
            <ParagraphSmall>Live value Data Explorer</ParagraphSmall>
            <TableBuilder
                data={tmpdata}
                isLoading={isLoading} size='compact'
            >
                <TableBuilderColumn header="Name">
                    {(row: any) => row.name}
                </TableBuilderColumn>

                <TableBuilderColumn header="Value">
                    {(row: any) => (
                        <CellSelector hasAccessObjectWrite={hasAccessObject} resourceGroupId={livestate.resourceGroupId} objectId={livestate.id} value={getLiveValue(row.name)} {...row}></CellSelector>
                    )}
                </TableBuilderColumn>
            </TableBuilder>
        </>
    );

    function getLiveValue(property: string): any {
        return livestate[property];
    }
};



const ResourceGroup = ({ resourceGroupId }: any) => {
    const [, theme] = useStyletron();
    const { data, isLoading, isError, error } = useGetResourceGroupByIdQuery(resourceGroupId);
    return (<ParagraphSmall margin={0} color={theme.colors.accent} >{data?.name}</ParagraphSmall>);
}

const Subscription = ({ resourceGroupId }: any) => {
    const [, theme] = useStyletron();
    const { data: dataSub, isLoading, isError, error } = useGetResourceGroupSubscriptionQuery(resourceGroupId);

    return (<ParagraphSmall margin={0} color={theme.colors.accent}>{dataSub?.name}</ParagraphSmall>);
}

export default ObjectPropertiesExplorer;
